<template>
  <div>
    <table-item :tableData="tableData" :col="col"></table-item>
  </div>
</template>
<script>
  import tableItem from './tableItem'
  export default {
    name: 'TableView',
    components: {
      tableItem
    },
    data() {
      return { // 树型结构表头数据
        col: [{
          "children": [],
          "prop": "甘肃电信员工疫情防控排查表",
          "label": "甘肃电信员工疫情防控排查表"
        }],

        // col: [{
        //   prop: 'date',
        //   label: '日期'
        // }, {
        //   label: '配送信息',
        //   children: [{
        //     prop: 'name',
        //     label: '姓名'
        //   }, {
        //     label: '地址',
        //     children: [{
        //       prop: 'province',
        //       label: '省份'
        //     }, {
        //       prop: 'city',
        //       label: '市区'
        //     }, {
        //       prop: 'address',
        //       label: '城镇'
        //     }]
        //   }]
        // }, {
        //   prop: 'remark',
        //   label: '备注'
        // }], // 表格数据

        tableData: []
        /* tableData: [{
          date: '2020-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          remark: '无'
        }, {
          date: '2020-05-02',
          name: '王小明',
          province: '上海',
          city: '浦东新区',
          address: '上海市浦东新区顾唐路 518 弄',
          remark: '学生'
        }, {
          date: '2020-05-02',
          name: '王小明',
          province: '上海',
          city: '浦东新区',
          address: '上海市浦东新区顾唐路 518 弄',
          remark: '学生'
        }, {
          date: '2020-05-02',
          name: '王小明',
          province: '上海',
          city: '浦东新区',
          address: '上海市浦东新区顾唐路 518 弄',
          remark: '学生'
        }, {
          date: '2020-05-02',
          name: '王小明',
          province: '上海',
          city: '浦东新区',
          address: '上海市浦东新区顾唐路 518 弄',
          remark: '学生'
        } ] */
      }
    }
  }
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableView.vue